@if (layoutName$ | async; as layoutName) {
  <ng-template
    [cxPageTemplateStyle]="layoutName"
    [cxOutlet]="layoutName"
    [cxOutletContext]="{
      templateName$: templateName$,
      slots$: slots$,
      section$: section$,
    }">
    <ng-content></ng-content>
    @for (slot of slots$ | async; track slot) {
      <cx-page-slot [position]="slot" [isPageFold]="slot === (pageFoldSlot$ | async)"></cx-page-slot>
    }
  </ng-template>
}
